var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommonTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25601 2.10115C2.22666 2.12218 2.19862 2.14588 2.17225 2.17225C2.14588 2.19862 2.12218 2.22666 2.10115 2.25601C1.93383 2.45794 1.83325 2.71718 1.83325 2.99992V12.9999C1.83325 13.6443 2.35559 14.1666 2.99992 14.1666H12.9999C13.2828 14.1666 13.5422 14.0659 13.7442 13.8984C13.7734 13.8774 13.8013 13.8538 13.8276 13.8276C13.8538 13.8013 13.8774 13.7734 13.8984 13.7442C14.0659 13.5422 14.1666 13.2828 14.1666 12.9999V2.99992C14.1666 2.35559 13.6443 1.83325 12.9999 1.83325H2.99992C2.71718 1.83325 2.45794 1.93383 2.25601 2.10115ZM12.8333 11.8904V3.16659H4.10939L12.8333 11.8904ZM11.8904 12.8333L3.16659 4.10939V12.8333H11.8904Z",
    fill: "#333A48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonTagIcon);
export default __webpack_public_path__ + "static/media/common-tag-icon.a3e5d1b6687f34ec58ff891665c6e3be.svg";
export { ForwardRef as ReactComponent };